'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { AlertCard } from '@/components/AlertCard';
import { VStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { toast } from '@/components/ui/use-toast';
import { accessRulesKeyPrefix, authPoliciesKeyPrefix, toAccessRuleFormValue, useAccessRule, useAuthenticationPolicyList, useSoftwareNameLookup, useUpdateAccessRule } from '@/features/authentication-policy';
import { handleApiError } from '@/lib/api/error';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { AccessRuleStepperScreen } from '../-components/AccessRuleStepperScreen';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/access-rules/$id/')({
  component: EditAccessRulePage
});
function EditAccessRulePage() {
  const {
    id
  } = Route.useParams();
  const {
    i18n,
    t
  } = useTranslation(defaultNS, {
    keyPrefix: accessRulesKeyPrefix
  });
  const {
    t: tPolicies
  } = useTranslation(defaultNS, {
    keyPrefix: authPoliciesKeyPrefix
  });
  const navigate = useNavigate();
  const {
    data,
    isPending,
    isError
  } = useAccessRule(id);
  const policyQuery = useAuthenticationPolicyList();
  const updateMutation = useUpdateAccessRule();
  const [errorMessage, setErrorMessage] = useState('');

  // applicationScope は ID のみなので、編集フォーム用に表示名を解決する
  const {
    resolveSoftwareName,
    isPending: isSoftwareNamesPending
  } = useSoftwareNameLookup(data?.applicationScope ?? []);
  const baseLink = `/settings/authentication/access-rules/${id}`;
  const backToList = () => navigate({
    to: '/settings/authentication/access-rules'
  });
  if (isPending || policyQuery.isPending || isSoftwareNamesPending) {
    return <ViewportLoader />;
  }
  if (isError || data == null) {
    return <VStack className="w-full gap-4 p-10">
        <AlertCard variant="mutedError" description={t($ => $.list.loadError)} />
      </VStack>;
  }
  if (policyQuery.isError || policyQuery.data == null) {
    return <VStack className="w-full gap-4 p-10">
        <AlertCard variant="mutedError" description={tPolicies($ => $.list.loadError)} />
      </VStack>;
  }
  return <AccessRuleStepperScreen key={data.id} baseLink={baseLink} isEdit initialValue={toAccessRuleFormValue(data, resolveSoftwareName)} isSubmitting={updateMutation.isPending} errorMessage={errorMessage} onSubmit={draft => {
    setErrorMessage('');
    updateMutation.mutate({
      ...draft,
      id
    }, {
      onSuccess: () => {
        toast({
          description: t($ => $.toast.updated)
        });
        void backToList();
      },
      onError: error => {
        setErrorMessage(handleApiError(error, {
          language: i18n.language
        }).message);
      }
    });
  }} />;
}